/**
 * @ngdoc object
 * @name templates
 * @description
 *
 */
angular
    .module('festzelt-os.statistics', [
        'ui.router',
        'festzelt-os.components'
    ]);

require('./directives/stats/stats-directive');



// WEBPACK FOOTER //
// ./src/app/pages/statistics/statistics-module.js